export const formatarTelefone = (valor: string): string => {
  valor = valor.replace(/\D/g, '')
  valor = valor.replace(/^(\d{2})(\d{1})(\d)/g, '($1) $2 $3')
  valor = valor.replace(/(\d)(\d{4})$/, '$1-$2')
  return valor
}
